import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  QueryList,
  ViewChildren
} from '@angular/core';

@Component({
  selector: 'app-otp-input',
  templateUrl: './otp-input.component.html',
  styleUrls: ['./otp-input.component.scss'],
  standalone: true
})
export class OtpInputComponent implements OnInit, AfterViewInit {
  @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef>;
  @Output() otpComplete: EventEmitter<string> = new EventEmitter<string>();

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.otpInputs.length > 0) {
        this.otpInputs.first.nativeElement.focus();
      }
    }, 100); // Затримка на короткий час для забезпечення коректної роботи
  }

  moveFocus(currentInput: HTMLInputElement, index: number): void {
    const length: number = currentInput.value.length;
    const maxLength: number = currentInput.maxLength;
    if (length >= maxLength) {
      const nextInput = this.otpInputs.toArray()[index + 1];
      if (nextInput) {
        nextInput.nativeElement.focus();
      } else {
        currentInput.blur();
      }
    }

    if (this.allFieldsFilled()) {
      this.emitOtp();
    }
  }

  handlePaste(event: ClipboardEvent): void {
    const clipboardData: DataTransfer | null = event.clipboardData;
    const pastedData: string = clipboardData
      ? clipboardData.getData('text')
      : '';
    const inputs: HTMLInputElement[] = this.otpInputs
      .toArray()
      .map((input) => input.nativeElement);

    if (pastedData.length === inputs.length) {
      inputs.forEach((input, index) => {
        input.value = pastedData[index] || '';
      });
      inputs[inputs.length - 1].focus();
    }

    if (this.allFieldsFilled()) {
      this.emitOtp();
    }
  }

  allFieldsFilled(): boolean {
    return this.otpInputs
      .toArray()
      .every((input) => input.nativeElement.value.length === 1);
  }

  emitOtp(): void {
    const otp: string = this.otpInputs
      .toArray()
      .map((input) => input.nativeElement.value)
      .join('');
    this.otpComplete.emit(otp);
  }
}
